import React from "react";
import { useTranslation } from "react-i18next";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const [t] = useTranslation();
  // Helper function to generate page numbers
  const getPageNumbers = () => {
    const pages = [];
    if (totalPages <= 5) {
      // Show all pages if total pages are 5 or less
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Show first, last, and middle dots
      if (currentPage <= 3) {
        pages.push(1, 2, 3, "...", totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(1, "...", totalPages - 2, totalPages - 1, totalPages);
      } else {
        pages.push(
          1,
          "...",
          currentPage - 1,
          currentPage,
          currentPage + 1,
          "...",
          totalPages
        );
      }
    }
    return pages;
  };

  let isPrevDisable = currentPage === 1;
  let isNextDisable = currentPage === totalPages;

  return (
    <div className="flex flex-col justify-center items-center gap-[8px] self-stretch mt-auto">
      <div className="flex gap-[4px] rounded-[8px] bg-white">
        <div
          className={`flex py-[10px] px-[16px] justify-center items-center gap-[8px] ${
            isPrevDisable ? "cursor-none" : " cursor-pointer"
          }`}
          onClick={() => {
            if (isPrevDisable) {
              return;
            }
            onPageChange(currentPage - 1);
          }}
        >
          <div
            className={`flex w-[32px] h-[32px] py-[6px] px-[10px] justify-center items-center gap-[6px] rounded-[6px] ${
              isPrevDisable
                ? "bg-[#F4F4F5]"
                : "bg-[#fff] border border-[#1E4A6B]"
            }`}
          >
            <div
              className={`text-[16px] w-[16px] h-[16px] mt-[-6px]  ${
                isPrevDisable ? "text-default-color" : "text-[#1E4A6B]"
              } `}
            >
              {"<"}
            </div>
          </div>
        </div>

        {getPageNumbers().map((page, index) =>
          typeof page === "number" ? (
            <button
              key={index}
              onClick={() => {
                onPageChange(page);
              }}
              className={`flex w-[32px] h-[32px]  py-[6px] px-[10x] my-auto justify-center items-center gap-[6px] rounded-[6px] font-medium ${
                page === currentPage ? "bg-primary" : "bg-[#fff]"
              }`}
            >
              <div
                className={`text-[14px] font-semibold pt-[3px] ${
                  page === currentPage ? "text-white" : "text-primary"
                }`}
              >
                {" "}
                {page}
              </div>
            </button>
          ) : (
            <span key={index} className="px-3 py-2 text-primary">
              ...
            </span>
          )
        )}

        <div
          className={`flex py-[10px] px-[16px] justify-center items-center gap-[8px] ${
            isNextDisable ? "cursor-none" : " cursor-pointer"
          }`}
          onClick={() => {
            if (isNextDisable) {
              return;
            }
            onPageChange(currentPage + 1);
          }}
        >
          <div
            className={`flex w-[32px] h-[32px] py-[6px] px-[10px] justify-center items-center gap-[6px] rounded-[6px] ${
              isNextDisable
                ? "bg-[#F4F4F5]"
                : "bg-[#fff] border border-[#1E4A6B]"
            }`}
          >
            <div
              className={`text-[16px] w-[16px] h-[16px] mt-[-6px]  ${
                isNextDisable ? "text-default-color" : "text-[#1E4A6B]"
              } `}
            >
              {">"}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Pagination;
